module.exports = __webpack_public_path__ + "static/media/avatar33.04b3dab9.png";